import { EnterpriseStatusBadge } from '../../../shared/components/EnterpriseStatusBadge';

interface BlueprintStatusBadgeProps {
  status: string;
  variant?: 'solid' | 'outline';
}

export function BlueprintStatusBadge({ status, variant = 'solid' }: BlueprintStatusBadgeProps) {
  const normalized = String(status || '').toLowerCase();
  const label = normalized === 'standard'
    ? 'Padrao'
    : normalized === 'published'
      ? 'Publicado'
      : normalized === 'archived'
        ? 'Arquivado'
        : 'Rascunho';
  const tone = normalized === 'standard'
    ? 'standard'
    : normalized === 'published'
      ? 'published'
      : normalized === 'archived'
        ? 'archived'
        : 'draft';

  return <EnterpriseStatusBadge label={label} tone={tone} className={variant === 'outline' ? 'bg-transparent' : ''} />;
}
